import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import KakaoButton from './components/KakaoButton';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import DirectionsPage from './pages/DirectionsPage';
import LoginPage from './pages/LoginPage';
import AdminLayout, { AdminIndex } from './components/AdminLayout';
import ImageManager from './components/ImageManager';
import VideoManager from './components/VideoManager';
import BookingManager from './components/BookingManager';
import PricingManager from './components/PricingManager';
import DealerInquiriesManager from './components/DealerInquiriesManager';
import UsedCarInquiriesManager from './components/UsedCarInquiriesManager';
import FAQManager from './components/FAQManager';
import FAQPage from './pages/FAQPage';
import AdminProfilesPage from './pages/AdminProfilesPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminCommunityPage from './pages/AdminCommunityPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import CommunityPage from './pages/CommunityPage';
import CommunityPostPage from './pages/CommunityPostPage';
import CommunityWritePage from './pages/CommunityWritePage';
import './App.css';

function AppRoutes() {
  return (
    <Routes>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminIndex />} />
            <Route path="images" element={<ImageManager />} />
            <Route path="videos" element={<VideoManager />} />
            <Route path="bookings" element={<BookingManager />} />
            <Route path="pricing" element={<PricingManager />} />
            <Route path="dealers" element={<DealerInquiriesManager />} />
            <Route path="used-car" element={<UsedCarInquiriesManager />} />
            <Route path="profiles" element={<AdminProfilesPage />} />
            <Route path="users" element={<AdminUsersPage />} />
            <Route path="faq" element={<FAQManager />} />
            <Route path="community" element={<AdminCommunityPage />} />
          </Route>
          <Route path="*" element={
            <div className="app-layout">
              <NavBar />
              <main className="app-content">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
                  <Route path="/directions" element={<DirectionsPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/faq" element={<FAQPage />} />
                  <Route path="/terms" element={<TermsPage />} />
                  <Route path="/privacy" element={<PrivacyPage />} />
                  <Route path="/community" element={<CommunityPage />} />
                  <Route path="/community/post/:id" element={<CommunityPostPage />} />
                  <Route path="/community/write" element={<CommunityWritePage mode="new" />} />
                  <Route path="/community/edit/:id" element={<CommunityWritePage mode="edit" />} />
                  <Route path="/community/:category" element={<CommunityPage />} />
                </Routes>
              </main>
              <Footer />
              <KakaoButton />
            </div>
          } />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
